import type { ReactNode } from 'react'
import { Card, Flex, Typography } from 'antd'

type MetricCardTone = 'blue' | 'green' | 'amber' | 'red' | 'neutral'

type MetricCardProps = {
  title: string
  value: ReactNode
  detail?: ReactNode
  icon?: ReactNode
  tone?: MetricCardTone
}

export function MetricCard({ title, value, detail, icon, tone = 'neutral' }: MetricCardProps) {
  return (
    <Card className={`metric-card metric-card-${tone}`}>
      <Flex align="flex-start" justify="space-between" gap="middle">
        <div>
          <Typography.Text type="secondary">{title}</Typography.Text>
          <div className="metric-value">{value}</div>
          {detail && <div className="metric-detail">{detail}</div>}
        </div>
        {icon && <div className="metric-icon">{icon}</div>}
      </Flex>
    </Card>
  )
}
